import { render, staticRenderFns } from "./SfPromotionPop.vue?vue&type=template&id=3c76e912"
import script from "./SfPromotionPop.vue?vue&type=script&lang=js"
export * from "./SfPromotionPop.vue?vue&type=script&lang=js"
import style0 from "./SfPromotionPop.vue?vue&type=style&index=0&id=3c76e912&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c76e912')) {
      api.createRecord('3c76e912', component.options)
    } else {
      api.reload('3c76e912', component.options)
    }
    module.hot.accept("./SfPromotionPop.vue?vue&type=template&id=3c76e912", function () {
      api.rerender('3c76e912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/popup/SfPromotionPop.vue"
export default component.exports